import type { JSX } from 'react'
import type { IButtonGroupProps } from '../ButtonGroup'

import { SecondaryOpacityFavoriteToggleButton } from 'atoms/ActionButton/Templates'
import {
  PlayPrimaryButton,
  SecondaryOpacityFontButton1Button,
} from 'atoms/Button/Templates'
import { ButtonGroup } from '../ButtonGroup'

export interface IButtonGroupTemplateTVShowsProps extends Omit<
  IButtonGroupProps,
  'children'
> {}

export const ButtonGroupTemplateTVShows = ({
  ...rest
}: IButtonGroupTemplateTVShowsProps): JSX.Element => (
  <ButtonGroup {...rest}>
    <PlayPrimaryButton title={'Resume'} />
    <SecondaryOpacityFontButton1Button title={'Trailer'} />
    <SecondaryOpacityFavoriteToggleButton />
  </ButtonGroup>
)
